import React, { useContext, useEffect, useRef } from 'react';

import type { Breadcrumb, BreadcrumbItem, MenuModel, MenuProps } from '../types';
import { Tooltip } from 'primereact/tooltip';
import AppMenuitem from './AppMenuitem';
import { LayoutContext } from './context/layoutcontext';
import { MenuProvider } from './context/menucontext';
import { useAppSelector } from 'app/config/store';
import { hasAnyAuthority } from 'app/shared/auth/private-route';

const AppSubMenu = (props: MenuProps) => {
  const { layoutState, setBreadcrumbs } = useContext(LayoutContext);
  const tooltipRef = useRef<Tooltip | null>(null);
  const account = useAppSelector(state => state.authentication.account);

  useEffect(() => {
    if (tooltipRef.current) {
      tooltipRef.current.hide();
      (tooltipRef.current as any).updateTargetEvents();
    }
  }, [layoutState.overlaySubmenuActive]);

  useEffect(() => {
    generateBreadcrumbs(props.model);
  }, []);

  const generateBreadcrumbs = (model: MenuModel[]) => {
    const breadcrumbs: Breadcrumb[] = [];

    const getBreadcrumb = (item: BreadcrumbItem, labels: string[] = []) => {
      const { label, to, items } = item;

      label && labels.push(label);
      items &&
        items.forEach(_item => {
          getBreadcrumb(_item, labels.slice());
        });
      to && breadcrumbs.push({ labels, to });
    };

    model.forEach(item => {
      getBreadcrumb(item);
    });
    setBreadcrumbs(breadcrumbs);
  };

  const filteredModel = props.model.filter(m => !m.requiredAuthorities || hasAnyAuthority(account.authorities, m.requiredAuthorities));

  return (
    <MenuProvider>
      <ul className="layout-menu">
        {filteredModel.map((item, i) => {
          return !item.seperator ? (
            <AppMenuitem item={item} root={true} index={i} key={item.label} />
          ) : (
            <li className="menu-separator"></li>
          );
        })}
      </ul>
      <Tooltip ref={tooltipRef} target="li:not(.active-menuitem)>.tooltip-target" />
    </MenuProvider>
  );
};

export default AppSubMenu;
